import { batch, signal } from "@preact/signals-react"
import {
	acriss,
	acrissCategory,
	analyzerDate,
	categories,
	currency,
	fuelPolicy,
	includeProviders,
	insurance,
	inTerminal,
	lengthRental,
	mileage,
	offices,
	officesPickoff,
	prepaid,
	priceKpi,
	providers,
	reports,
	repricingPass,
	singleDate,
	sites,
	transmission, userData, webSuppliers, acrissGroups
} from "@signals"
import { TABLE_TAB_SELECTED } from "Pages/AnalyzersV2/@constants"
import { resetPassView } from "Pages/AnalyzersV2/@services/passView"
import { ALL_CARS } from "Pages/AnalyzersV2/@services/carPick"

export const dateAvailable = signal([])
export const tableTabSelected = signal(TABLE_TAB_SELECTED.MIN)
export const responseData = signal({})
export const isAnalyzerLoading = signal(false)
export const featuresList = signal([])
export const analyzerFilters = signal([])
export const openEvolutionModal = signal({})
export const analyzerChartVisibility = signal([])
export const evolutionChartVisibility = signal([])
export const tableHideDetails = signal(userData.value?.onlyPricesAnalyzerTable)
export const tableHasMainComparison = signal(false)
export const hasNoCurrencyResults = signal(false)
// the engine answered 404 for what is open (a pass or execution of another account, or deleted): no price is drawn
export const analyzerNotFound = signal(false)
// the engine's decisions of the open pass on the cells (CU-869fmm949): the server's answer, and the toolbar switch
export const passDecisions = signal(null)
export const showPassDecisions = signal(true)
// the Cars selector above the price table of DOR, LOR and Rank Analyzer (CU-869fmpqfm): one car, or All cars. Kept
// across Min / Max, Total / Daily, dates, lengths and Search; back to All on a new report, pass, office or page
export const analyzerCarPick = signal(ALL_CARS)
// a new answer is on its way while the table on screen stays (a car picked, Min / Max): the "Updating…" veil
export const analyzerUpdating = signal(false)
// the request failed with a table on screen: `{ status, retry }`, a note in the card instead of the table
export const analyzerError = signal(null)
// the execution's option filters the band's autocompletes use, so the Cars field lists the same cars
export const analyzerOptionFilters = signal({})
//functions
export const resetSignals = (clearTab) => batch(() => {
	if (clearTab) {
		tableTabSelected.value = TABLE_TAB_SELECTED.MIN
	}
	dateAvailable.value = []
	responseData.value = {}
	featuresList.value = []
	analyzerFilters.value = []
	openEvolutionModal.value = {}
	tableHasMainComparison.value = false
	hasNoCurrencyResults.value = false
	passDecisions.value = null
	analyzerUpdating.value = false
	analyzerError.value = null
})


export const resetCustomFilters = () => batch(() => {
	resetSignals()
	analyzerCarPick.value = ALL_CARS
	// a new execution opens with the decision marks on (CU-869fmm949, criterion 3)
	resetPassView({ showPassDecisions })
	acriss.value = []
	transmission.value = []
	categories.value = []
	fuelPolicy.value = []
	singleDate.value = null
	providers.value = []
	prepaid.value = []
	mileage.value = []
	webSuppliers.value = []
	// the groups are the acriss axis of One Way, and a stale selection would satisfy its
	// mandatory validation with values of another execution
	acrissGroups.value = []
	lengthRental.value = null
	priceKpi.value = false
	inTerminal.value = []
	insurance.value = []
	includeProviders.value = userData.value?.WebProviderAnalyzerGroupDefault
	acrissCategory.value = false
	sites.value = null
	currency.value = null
	offices.value = null
	reports.value = null
	repricingPass.value = null
	officesPickoff.value = null
	analyzerDate.value = null
	tableHideDetails.value = userData.value?.onlyPricesAnalyzerTable
})
